import React from 'react';
import { getDisplayName } from 'helpers/component';

export default function OnMountHomeScrollEnhancer() {
    return function OnMountHomeScrollHOC(WrappedComponent) {
        class OnMountHomeScroll extends React.Component {
            componentDidMount() {
                window.scroll(0, 0); // mo betta
            }

            render() {
                return <WrappedComponent {...this.props} />;
            }
        }

        OnMountHomeScroll.displayName = `OnMountHomeScroll(${getDisplayName(WrappedComponent)})`;

        return OnMountHomeScroll;
    };
}



// WEBPACK FOOTER //
// ./src/hoc/OnMountHomeScroll.js